import { useQuery } from '@tanstack/react-query';
import { getVisitaVigente } from '../api/common';

export const VISITA_VIGENTE_KEY = (programacionId) => ['visitaVigente', programacionId];

export function useVisitaVigente(programacionId) {
  return useQuery({
    queryKey: VISITA_VIGENTE_KEY(programacionId),
    queryFn: async () => {
      const r = await getVisitaVigente({ programacionId });
      return r.data.visita || null;
    },
    staleTime: 3 * 60 * 1000,
    enabled: !!programacionId,
  });
}
